import DOMPurify from 'dompurify'

export function handsontableSanitizerOptions(source) {
  if (source === 'CopyPaste.paste.sourceData') {
    return {
      ADD_TAGS: ['meta'],
      ADD_ATTR: ['content'],
      FORCE_BODY: true
    }
  }

  return undefined
}

export function sanitizeHandsontableHtml(content, source) {
  return DOMPurify.sanitize(content, handsontableSanitizerOptions(source))
}
